import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import StyledFrame from './BillerVerified.frame';
import * as infoboxActions from '../../../../redux/actions/infobox.actions';
import { prebillerVerifiedDisabled, prebillerVerifiedEaRunStatusUnavailable } from '../../../../flags/prebilling.flag';
import { eaRunStatusUnavailable } from '../../../../messages';
import getBillerVerifiedTooltip from '../../../../parsers/tooltip.parser';
import { agencyRequiresCoverage } from 'flags/valid.flag';

const BillerVerifiedContainer = props => <StyledFrame {...props} />;

function mapStateToProps(state) {
  return {
    isBillerVerified: state.requests.isBillerVerified,
    prebillerVerifiedDisabled: prebillerVerifiedDisabled(state),
    isBillerVerifiedTooltip: getBillerVerifiedTooltip(state),
    eaRunStatusWarning: prebillerVerifiedEaRunStatusUnavailable(state) ? eaRunStatusUnavailable : '',
    billerVerifiedAt: moment(state.requests.billerVerifiedAt).format('MM/DD'),
    billerVerifiedBy: state.requests.billerVerifiedBy,
    loadedRequest: state.formFlow.loadedRequest,
    coverageRequired: agencyRequiresCoverage(state),
  };
}

export default connect(mapStateToProps, {
  ...infoboxActions,
})(BillerVerifiedContainer);
